<template>
  <div class="invite-record">
    <div class="main-title">
      <p>
        <span class="bold-text">用户邀请记录</span>
      </p>
    </div>
    <div class="main-body">
      <div class="filter-bar">
        <div class="item">
          <span>邀请人手机号：</span>
          <el-input v-model="inviterMobilePhone" placeholder="请输入邀请人手机号"></el-input>
        </div>
        <div class="item">
          <span>被邀请人手机号：</span>
          <el-input v-model="inviteeMobilePhone" placeholder="请输入被邀请人手机号"></el-input>
        </div>
        <div class="item">
          <span>所属组织：</span>
          <el-cascader
            class="fixed-width-200"
            :options="unitList"
            :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }"
            v-model="unitNos"
            clearable></el-cascader>
        </div>
        <div class="item">
          <span>邀请状态：</span>
          <el-select v-model="inviteStatus">
            <el-option v-for="(item, index) in inviteStatusList" :label="item.label" :value="item.value"
                       :key="index"></el-option>
          </el-select>
        </div>
        <div class="item">
          <el-button type="primary" @click="getDataList">查询</el-button>
          <el-button type="primary" @click="confirmDownloadBtnClick">导出</el-button>
        </div>
      </div>

      <table class="table-custom" style="margin-top: 20px">
        <thead>
        <tr>
          <th style="width: 150px">邀请人账户编号</th>
          <th>邀请人手机号</th>
          <th>邀请人姓名</th>
          <th style="width: 150px">邀请人所属组织</th>
          <th>被邀请人手机号</th>
          <th>邀请状态</th>
          <th style="width: 150px">注册时间</th>
          <th style="width: 150px">收货时间</th>
          <th style="width: 150px">被邀请人订单号</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item, index) in dataList" :key="index">
          <td>{{ item.inviterAccountNo }}</td>
          <td>{{ item.inviterMobilePhone }}</td>
          <td>{{ item.inviterName }}</td>
          <td>{{ item.inviterBelongUnit }}</td>
          <td>{{ item.inviteeMobilePhone }}</td>
          <td>{{ item.inviteStatus }}</td>
          <td>{{ item.registerTime }}</td>
          <td>{{ item.receivingTime }}</td>
          <td>{{ item.inviteeOrderNo }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="9" style="text-align: center">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ currentPage }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">
          跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="toPage">跳转</div>
        <div class="pre-btn" :class="beginIndex <= 0 ? 'disabled' : ''" @click="prevPage">上一页</div>
        <div class="next-btn" :class="reachEnd ? 'disabled' : ''" @click="nextPage">下一页</div>
      </div>
    </div>
  </div>
</template>

<script>
import {parseTime} from "../../utils";

export default {
  name: "userInviteRecord",
  data() {
    return {
      inviterMobilePhone: '',
      inviteeMobilePhone: '',
      unitNos: [],
      unitList: [],
      inviteStatus: '',
      inviteStatusList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已注册',
          value: '1'
        },
        {
          label: '已收货',
          value: '2'
        }
      ],
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      total: 0,
      page: '',
      reachEnd: true
    }
  },

  computed: {
    currentPage() {
      return Math.floor(this.beginIndex / this.pageSize) + 1
    },
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },

  mounted() {
    this.getUnitMember();
    this.getDataList();
  },

  methods: {
    getUnitMember() {
      let params = {
        authorityType: 201
      }
      this.$http.post('/managementPlatform/unit/queryManagedUnit', this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        this.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },

    getDataList() {
      let params = {
        inviteeMobilePhone: this.inviteeMobilePhone,
        inviterMobilePhone: this.inviterMobilePhone,
        unitNo: this.unitNos[this.unitNos.length - 1] || '',
        inviteStatus: this.inviteStatus,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      }
      this.$http.get('/managementPlatform/electricity/getUserInviteRecordList?' + this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.reachEnd = res.ldata.length < this.pageSize + 1;
        if (!this.reachEnd) {
          res.ldata.pop();
        }
        res.ldata.forEach(ele => {
          ele.registerTime = parseTime(ele.registerTime) || '';
          ele.receivingTime = parseTime(ele.receivingTime) || '';
        })
        this.dataList = res.ldata;
        this.total = res.mdata.total || '0'
      }).catch(function (response) {
        console.log(response);
      });
    },

    toPage() {
      if (!this.page || isNaN(this.page)) {
        return this.$message.warning("请输入跳转的页数");
      }
      this.page = parseInt(this.page);
      if (this.pageSize < 1 || this.page > this.totalPage) {
        return this.$message.warning("请输入正确的页码");
      }
      this.beginIndex = (this.page - 1) * this.pageSize;
      this.getDataList();
    },

    prevPage() {
      this.beginIndex -= this.pageSize;
      this.getDataList();
    },

    nextPage() {
      this.beginIndex += this.pageSize;
      this.getDataList();
    },
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm("是否确认导出?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.downloadBtnClick();
        })
        .catch(action => {
        });
    },
    downloadBtnClick() {
      let params = {
        inviteeMobilePhone: this.inviteeMobilePhone,
        inviterMobilePhone: this.inviterMobilePhone,
        unitNo: this.unitNos[this.unitNos.length - 1] || '',
        inviteStatus: this.inviteStatus
      }
      this.$http.get('/managementPlatform/electricity/createUserInviteRecordExportTask?' + this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.$message.success("导出成功！")
        setTimeout(() => {
          this.$router.push("/managePage/downloadTask")
        }, 2000)
      }).catch(function (response) {
        console.log(response);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-record {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select {
        width: 180px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/userInviteRecord.vue